export default __webpack_public_path__ + "static/media/sudokusolver.15b52ecf.png";